module.exports = __webpack_public_path__ + "img/20191111165854860.5628ea3e.jpg";